<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import { mapState } from 'vuex'
import FallbackAvatar from '@/components/ui/FallbackAvatar'

export default {
  name: 'AppBar',
  components: {
    FallbackAvatar,
  },
  props: {
    barBgColor: {
      default: 'main-darken-5',
      type: String,
    },
    logoText: String,
    user: Object,
  },
  computed: {
    ...mapState('auth', [
      'location',
      'settings',
    ]),
    getLogo() {
      return this.settings && this.settings.base_options && this.settings.base_options.show_company_logo &&
        this.location && this.location.image ?
          this.location.image :
          this.customerConfig.images.logo
    },
  },
}
</script>
